import { render, staticRenderFns } from "./offer-list.vue?vue&type=template&id=58d6b622&"
import script from "./offer-list.vue?vue&type=script&lang=ts&"
export * from "./offer-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "offer-list.vue"
export default component.exports